import http from '../plugins/http'
import {
    DELETE_DOCUMENT,
    DELETE_GROUP,
    DOCUMENT,
    DOWNLOAD_DOCUMENT,
    DOWNLOAD_GROUP_DOCUMENT,
    GROUP_DOCUMENT
} from '@/config/config_api_backend'
import _ from 'lodash'
import {DeleteType, DocumentStateType, DownloadType, GroupStateType} from '@/constants/DoITConstant'
import stringInject from 'stringinject'

const apiGetAllDocument = async (params) => {
    try {
        let response = await http.get(DOCUMENT.GET_DOCUMENT_ALL, {
            params: params,
        },)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

export const apiGetDocumentStatistic = async () => {
    let response = await http.get(DOCUMENT.GET_DOCUMENT_STATISTIC)
    return response.data
}

const apiGetAllDocumentByTag = async (id, params) => {
    let url = stringInject(DOCUMENT.GET_ALL_DOCUMENT_BY_TAG, {'id': id})
    try {
        let response = await http.get(url, {
            params: params,
        },)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiGetAllDocumentByGroup = async (id, params) => {
    let url = stringInject(GROUP_DOCUMENT.GET_ALL_DOCUMENT_BY_GROUP, {'id': id})
    try {
        let response = await http.get(url, {
            params: params,
        },)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}


let apiGetListGroupDocumentInfo = async (listDocumentIDs) => {
    try {
        let response = await http.get(GROUP_DOCUMENT.GET_LIST_DOCUMENTS_INFO, {
            params: {
                listDocumentIDs: listDocumentIDs.join(',')
            }
        })
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}


const apiDownloadBatchDocument = async (slugs, type) => {
    try {
        let url = stringInject(DOWNLOAD_DOCUMENT.BATCH_DOC, {'type': type})
        let response = await http.post(url, JSON.stringify([...slugs]), {
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'arraybuffer'
        })
        return response.data
    } catch (e) {
        if (e.response && e.response.status !== 204) return null
        else return ''
    }
}

const apiResetDocumentAction = async (slug) => {
    try {
        let url = stringInject(DOCUMENT.RESET_READ_ACTION, {'slug': slug})
        let response = await http.post(url)
        return response.data
    } catch (e) {
        if (e.response && e.response.status !== 204) return null
        else return ''
    }
}

const apiMarkDocumentAsRead = async (slug) => {
    try {
        let url = stringInject(DOCUMENT.MARK_AS_READ, {'slug': slug})
        let response = await http.post(url)
        return response.data
    } catch (e) {
        if (e.response && e.response.status !== 204) return null
        else return ''
    }
}


const apiDownloadBatchGroupDocument = async (slugs, type) => {
    try {
        let url = stringInject(DOWNLOAD_GROUP_DOCUMENT.BATCH_DOC, {'type': type})
        console.log(slugs)
        let response = await http.post(url, JSON.stringify([...slugs]), {
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'arraybuffer'
        })
        return response.data
    } catch (e) {
        if (e.response && e.response.status !== 204) return null
        else return ''
    }
}


const apiDownloadALlDocumentInTag = async (tagId, type) => {
    try {
        let url = stringInject(DOWNLOAD_DOCUMENT.BATCH_DOC_IN_TAG, {'tagId': tagId, 'type': type})
        let response = await http.get(url, {
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'arraybuffer'
        })
        return response.data
    } catch (e) {
        if (e.response && e.response.status !== 204) return null
        else return ''
    }
}

const apiDownloadALlDocumentInGroup = async (groupId, type) => {
    try {
        let url = stringInject(DOWNLOAD_GROUP_DOCUMENT.BATCH_DOC_IN_GROUP, {'groupId': groupId, 'type': type})
        let response = await http.get(url, {
            headers: {
                'Content-Type': 'application/json',
            },
            responseType: 'arraybuffer'
        })
        return response.data
    } catch (e) {
        if (e.response && e.response.status !== 204) return null
        else return ''
    }
}


const apiDownloadDocumentAsArrayBuffer = async (slug, type) => {
    try {
        let url = stringInject(DOWNLOAD_DOCUMENT.DOC, {'slug': slug, 'type': type})
        let response = await http.get(url,
            {
                responseType: 'arraybuffer'
            })
        return response.data
    } catch (e) {

        if (e.response && e.response.status !== 204) return null
        else return ''
    }
}

const apiDownloadAsArrayBuffer = async (url) => {
    try {
        let response = await http.get(url,
            {
                responseType: 'arraybuffer'
            })
        return response.data
    } catch (e) {
        if (e.response.status === 204) {
            return ''
        }
        return null
    }
}


const apiDownloadGroupDocumentAsArrayBuffer = async (slug, type) => {
    try {
        let url = stringInject(DOWNLOAD_GROUP_DOCUMENT.DOC, {'slug': slug, 'type': type})
        let response = await http.get(url,
            {
                responseType: 'arraybuffer'
            })
        return response.data
    } catch (e) {

        if (e.response && e.response.status !== 204) return null
        else return ''

    }
}

const apiGetDocummentSummaryResult = async (slug) => {
    try {
        let url = stringInject(DOCUMENT.GET_SUMMARY_RESULT, {'slug': slug})
        let response = await http.get(url)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiGetGroupDocummentSummaryResult = async (slug) => {
    try {
        let url = stringInject(GROUP_DOCUMENT.GET_SUMMARY_RESULT, {'slug': slug})
        let response = await http.get(url)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiGetDocumentInfo = async (slug) => {
    try {
        let url = stringInject(DOCUMENT.GET_DOCUMENT_INFO, {'slug': slug})
        // console.log('slug', slug)
        // console.log('url get info', url)
        let response = await http.get(url)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}


const apiGetGroupDocumentInfo = async (slug) => {
    try {
        let url = stringInject(GROUP_DOCUMENT.GET_DOCUMENT_INFO, {'slug': slug})
        // console.log('slug', slug)
        // console.log('url get info', url)
        let response = await http.get(url)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiDeleteDocument = async (slug, type) => {

    try {

        let baseUrl = ''

        switch (type) {
            case DeleteType.FORCE:
                baseUrl = DELETE_DOCUMENT.FORCE_DELETE
                break
            case DeleteType.SOFT:
                baseUrl = DELETE_DOCUMENT.SOFT_DELETE
                break
        }

        let url = stringInject(baseUrl, {'slug': slug})
        let response = await http.delete(url)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

const apiDeleteGroup = async (id) => {
    try {
        let url = stringInject(DELETE_GROUP.FORCE_DELETE, {'id': id})
        let response = await http.delete(url)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }

}

const apiCheckDocument = async (slug) => {
    try {
        let baseUrl = DOCUMENT.CHECK_DOCUMENT
        let url = stringInject(baseUrl, {'slug': slug})
        let response = await http.get(url)
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}


const apiGetDocumentStateByStateId = (state_id) => {
    return _.find(DocumentStateType, {name: state_id})
}

const apiGetGroupStateByStateId = (state_id) => {
    return _.find(GroupStateType, {name: state_id})
}

const apiCreateDocument = async (file, title, pages, author, onFail) => {
    try {
        const formData = new FormData()
        formData.append('file', file)
        formData.append('pages', pages)
        formData.append('title', title)
        formData.append('author', author)

        let response = await http.put(DOCUMENT.PUT_DOCUMENT,
            formData,
            {'Content-Type': 'multipart/form-data'})

        return response.data
    } catch (e) {
        console.log(e)
        onFail(e)
        return null
    }
}

const apiUpdateDocument = async (slug, title, author) => {
    const formData = new FormData()
    formData.append('title', title)
    formData.append('author', author)
    let url = stringInject(DOCUMENT.POST_DOCUMENT, {'slug': slug})
    let response = await http.post(url, formData, {'Content-Type': 'multipart/form-data'})
    return response.data
}

const apiUpdateGroupDocument = async (slug, title) => {
    const formData = new FormData()
    formData.append('title', title)
    let url = stringInject(GROUP_DOCUMENT.POST_DOCUMENT, {'slug': slug})
    let response = await http.post(url, formData, {'Content-Type': 'multipart/form-data'})
    return response.data
}

const apiShareGrantDocument = async (description, slug, tagId, userEmail) => {
    const formData = new FormData()

    formData.append('description', description)
    formData.append('slug', slug)
    formData.append('tagId', tagId)
    formData.append('userEmail', userEmail)


    let response = await http.post(DOCUMENT.SHARE_GRANT,
        formData,
        {
            'Content-Type': 'multipart/form-data'
        })
    return response.data
}
const apiShareDenyDocument = async (description, slug, tagId, userEmail) => {
    try {
        const formData = new FormData()

        formData.append('description', description)
        formData.append('slug', slug)
        formData.append('tagId', tagId)
        formData.append('userEmail', userEmail)


        let response = await http.post(DOCUMENT.SHARE_DENY,
            formData,
            {
                'Content-Type': 'multipart/form-data'
            })
        return response.data
    } catch (e) {
        console.log(e)
        return null
    }
}

export {
    apiGetAllDocument,
    apiGetAllDocumentByTag,
    apiGetDocumentStateByStateId,
    apiDownloadBatchDocument,
    apiDownloadALlDocumentInTag,
    apiGetAllDocumentByGroup,
    apiGetGroupDocumentInfo,
    apiGetDocumentInfo,
    apiDeleteDocument,
    apiDeleteGroup,
    apiCreateDocument,
    apiDownloadDocumentAsArrayBuffer,
    apiUpdateDocument,
    apiCheckDocument,
    apiShareGrantDocument,
    apiShareDenyDocument,
    apiGetListGroupDocumentInfo,
    apiDownloadBatchGroupDocument,
    apiDownloadALlDocumentInGroup,
    apiDownloadGroupDocumentAsArrayBuffer,
    apiUpdateGroupDocument,
    apiDownloadAsArrayBuffer,
    apiGetGroupStateByStateId,
    apiGetDocummentSummaryResult,
    apiGetGroupDocummentSummaryResult,
    apiResetDocumentAction,
    apiMarkDocumentAsRead
}
